import { executionEnvironment } from "@x1-utils/ExecutionEnvironment";
import { gkx } from "@x1-utils/gkx";

import { X1DarkModeRootClass } from "./X1DarkModeRootClass";
import { X1DarkModeSetting } from "./X1DarkModeSetting";

let currentSetting = X1DarkModeSetting.initialSetting;
const listeners = new Set();

function getDarkModeSetting() {
  return !gkx[22823] ? "DISABLED" : currentSetting;
}

function saveDarkModeSetting(newSetting, { onRevert }) {
  if (!executionEnvironment.canUseDOM) {
    return;
  }

  let previousSetting = currentSetting;
  if (previousSetting === newSetting) {
    return;
  }

  updateSetting(newSetting);
}

function updateSetting(newSetting) {
  currentSetting = newSetting;
  let updatedSetting = getDarkModeSetting();

  listeners.forEach((callback) => {
    return callback(updatedSetting);
  });

  if (gkx[22823]) {
    X1DarkModeRootClass.updateDarkModeRootClass(updatedSetting);
  }
}

function initDarkMode() {
  X1DarkModeRootClass.updateDarkModeRootClass(getDarkModeSetting());
}

export const X1DarkMode = {
  getDarkModeSetting,
  saveDarkModeSetting,
  initDarkMode,
};
